import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function DreamhomeOutlineIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M21 9.5V21H19V10.5L12.6001 5.69971C12.2476 5.43506 11.7529 5.43457 11.3994 5.7002L5.00001 10.4999V21H3V4H5V8L10.1997 4.1001C11.2607 3.30518 12.7407 3.30567 13.7998 4.09961L21 9.5Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M8.25488 17.6012L11.925 21L15.7651 17.5824C16.7494 16.5387 16.7494 14.8399 15.7651 13.7962C15.2814 13.2828 14.6362 13 13.9485 13C13.2607 13 12.6155 13.2828 12.1317 13.7958C12.086 13.8442 12.0424 13.8946 12.0005 13.9461C11.9586 13.8946 11.9148 13.8446 11.8693 13.7962C11.3855 13.2828 10.7403 13 10.0525 13C9.36483 13 8.71965 13.2828 8.23586 13.7962C7.25157 14.8399 7.25157 16.5387 8.25488 17.6012Z",
    fill: "currentColor"
  }));
}